// @flow @jsx h
/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */

import { Component, h } from 'preact'
import { bem } from '@nrk/dh-utils'
import Link from './Link/index'
import { OrderudLogo } from './OrderudLogo'
import styles from './index.css'
import type { MenuItemType } from './types'
import { connect } from '../../../lib/provider'

type Props = {
  menuItems: Array<MenuItemType>,
  contextId: string,
  sendGaEvent: any => void
}

type State = {
  expanded: boolean,
  dirty: boolean
}

class Menu extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      expanded: false,
      dirty: false
    }
  }

  handleExpand = () => {
    this.setState({ expanded: !this.state.expanded, dirty: true })
    this.props.sendGaEvent({ action: this.state.expanded ? 'OPEN_MENU' : 'CLOSE_MENU', label: 'ORDERUD_MENU' })
  }

  render () {
    const { expanded, dirty } = this.state
    const { menuItems, contextId } = this.props
    const fadeIn = dirty && expanded
    const fadeOut = dirty && !expanded

    return (
      <div class={bem(styles.menuContainer, { expanded })}>
        <nav class={styles.menu}>
          <button onClick={this.handleExpand} aria-expanded={expanded.toString()}>
            <OrderudLogo />
            <span className='nrk-sr'>Gåten Orderud – Meny</span>
          </button>
          <div class={bem(styles.menu__submenu, { fadeIn, fadeOut })} aria-hidden={!expanded}>
            <ul>
              {
                menuItems.map(menuItem => {
                  return <li key={menuItem.url}>
                    <Link menuItem={menuItem} current={menuItem.id === contextId} />
                  </li>
                })
              }
            </ul>
          </div>
        </nav>
      </div>
    )
  }
}

const connector = connect()
export default connector(Menu)
